// ============================================================================
// REVERSE GEOCODING
// Coordinates → readable address via OpenStreetMap Nominatim.
//
// Nominatim needs no API key, which is why it is used here: the CRM's map is
// already OSM/Leaflet and there is no Google Maps key on the web side.
// Its usage policy caps callers at ~1 request/second, so this is only for
// one-off lookups (sharing a location), never a polling loop.
// ============================================================================

const NOMINATIM_URL = 'https://nominatim.openstreetmap.org/reverse';
const TIMEOUT_MS = 8000;

/**
 * @returns {Promise<string|null>} formatted address, or null when the lookup
 *   fails. Callers should send null/'' rather than substituting coordinates —
 *   raw numbers read as a broken address wherever they surface.
 */
export const reverseGeocode = async (lat, lng) => {
  if (lat == null || lng == null) return null;

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const url = `${NOMINATIM_URL}?format=jsonv2&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`;
    const res = await fetch(url, {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data?.display_name || null;
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
};

export default reverseGeocode;
